import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import { useOcTwoFactorEnabledDateState } from "oc/hooks";

interface MyHrLoginTwoFactorInfoProps {
  onCancel: () => void;
  onForward: (type: string) => void;
  isMobile: boolean;
}

export const MyHrLoginTwoFactorInfo: React.FC<MyHrLoginTwoFactorInfoProps> = ({
  onCancel,
  onForward,
  isMobile,
}) => {
  const { t } = useTranslation();

  const { state: twoFaEnabledDate } = useOcTwoFactorEnabledDateState();
  const date = new Date(twoFaEnabledDate).toLocaleDateString();

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Box sx={{ textAlign: "left", marginTop: "24px", marginBottom: "16px" }}>
        <Typography variant="body1" sx={{ marginBottom: "8px" }}>
          {t("MY_HR_2FA_MANDATORY_FROM_DATE", { date })}
        </Typography>
        <Typography variant="body1">{t("MY_HR_2FA_DESCRIPTION")}</Typography>
      </Box>
      <Button
        id="two-factor-select-type"
        variant="contained"
        color="primary"
        sx={{ marginTop: "16px" }}
        onClick={() => onForward("two-factor-select-type")}
        fullWidth
      >
        {t("OC_NEXT")}
      </Button>
      <Button
        id="cancel"
        variant="text"
        fullWidth
        color="secondary"
        sx={{ color: "#212121", marginTop: "32px" }}
        onClick={onCancel}
      >
        {t("OC_CANCEL")}
      </Button>
    </Box>
  );
};

export default MyHrLoginTwoFactorInfo;
